'use strict';

export class SearchNavigation {
	constructor($element) {
		this.$root_element = jQuery('.js-searchnavigation');
		this.$buttons = this.$root_element.find('.js-searchnavigation_arrow');
		this.$aside = jQuery('.js-aside');
		this.$aside_backdrop = jQuery('.js-aside_backdrop');
	}
	
	init() {
		this.$root_element.on('click', '.js-searchnavigation_arrow', this.ajax.bind(this));
		this.$root_element.on('click', '.js-searchnavigation_show_more', this.show_more.bind(this));
		this.$root_element.on('click', '.js-searchnavigation_show_less', this.show_less.bind(this));
		this.$root_element.on('click', '.js-searchnavigation_results_back', this.results_back.bind(this));
		jQuery('.js-searchnavigation_toggle').on('click.aside', this.toggle_aside.bind(this));
		jQuery(document).on('click', '.js-searchnavigation_places_show_more', this.places_show_more.bind(this));
		jQuery(document).on('click', '.js-searchnavigation_places_show_less', this.places_show_less.bind(this));
	}
	places_show_more(event) {
		const $button = jQuery(event.currentTarget);
		const $list = $button.closest('ul');
		yalwa.basics.show($list.children('.js-no_link'));
		yalwa.basics.show($button.closest('li').next());
		yalwa.basics.hide($button.closest('li'));
	}
	places_show_less(event) {
		const $button = jQuery(event.currentTarget);
		const $list = $button.closest('ul');
		yalwa.basics.hide($list.children('.js-no_link'));
		yalwa.basics.show($button.closest('li').prev());
		yalwa.basics.hide($button.closest('li'));
	}
	
	safari_z_index_handled = false;
	safari_z_index_handling() {
		if (this.safari_z_index_handled) {
			return;
		}
		this.$aside_backdrop.detach().insertBefore('.js-ybtb');
		this.$aside.detach().insertBefore('.js-ybtb');
		this.safari_z_index_handled = true;
	}
	get track() {
		return ['open'].reduce((accumulator, action) => {
			accumulator[action] = () => yalwa.basics.ga.event({
				category: 'categories_button_click',
				action
			});
			return accumulator;
		}, {});
	}
	toggle_aside() {
		// z-index on safari handled differently also
		if (
			yalwa.basics.is_safari() &&
			matchMedia(`(max-width: ${jQuery('html').css('--bp_tablet')})`).matches
		) {
			this.safari_z_index_handling();
		}
		if (!this.$aside.hasClass('toggled')) {
			this.track.open();
		}
		this.$aside.toggleClass('toggled');
		this.$aside_backdrop.toggleClass('toggled');
		this.$aside_backdrop.off('click.aside').on('click.aside', this.toggle_aside.bind(this));
	}
	
	ajax(event) {
		const $button = jQuery(event.currentTarget);
		const $item = $button.closest('.js-item');
		const $child_container = $item.children('.js-searchnavigation_children_container');
		$button.css('pointer-events', 'none');
		if (!$child_container.is(':empty')) {
			this.toggle(event);
			return;
		}
		const data = {
			id: jQuery(event.currentTarget).data('id'),
			layer: jQuery(event.currentTarget).data('layer'),
		}
		if (parseInt(yalwa.v.current_geoID) > 0) {
			data['geoID'] = yalwa.v.current_geoID;
		}
		if (yalwa.v.request) {
			data['request'] = yalwa.v.request;
		}
		if(yalwa.v.cat_restricted_query_form) {
			data['cat_restricted_query_form'] = yalwa.v.cat_restricted_query_form;
		}
		yalwa.basics.ajaxservice({
			type: 'POST',
			resource: 'searchnavigation',
			action: 'category',
			data: data
		}).then(response => {
			if (response.success) {
				$child_container.replaceWith(response.html);
				this.toggle(event, true);
			}
		});
	}
	toggle(event, is_after_ajax = false) {
		const $button = jQuery(event.currentTarget);
		const $item = $button.closest('.js-item');
		const $child_container = $item.children('.js-searchnavigation_children_container');
		$button.css('pointer-events', 'initial');
		yalwa.basics.bem_modifier($button, 'expanded', 'toggle');
		yalwa.basics.bem_modifier($item, 'expanded', 'toggle');
		if (!is_after_ajax) {
			yalwa.basics.bem_modifier($child_container, 'expanded', 'toggle');
		}
	}
	show_more(event) {
		const $button = jQuery(event.currentTarget);
		const $child_container = $button.closest('.js-searchnavigation_children_container');
		const $items = $child_container.children('.js-no_link');
		const $show_less_button = $button.next();
		yalwa.basics.show($items);
		yalwa.basics.show($show_less_button);
		yalwa.basics.hide($button);
	}
	show_less(event) {
		const $button = jQuery(event.currentTarget);
		const $child_container = $button.closest('.js-searchnavigation_children_container');
		const $show_more_button = $button.prev();
		const $items = $child_container.children('.js-no_link');
		yalwa.basics.hide($items);
		yalwa.basics.show($show_more_button);
		yalwa.basics.hide($button);
	}
	results_back(event) {
		window.history.back();
	}
}

